import React from 'react';
import ErrorLabel from 'shared/form-fields/ErrorLabel';

function SubLabelSection(props) {
  const { showError, error, subLabel, forceShowError } = props;
  if (!(showError || subLabel || forceShowError)) {
    return null;
  }

  return (
    <div className="subLabelWrapper">
      {subLabel && !showError && <small className="subLabel">{subLabel}</small>}
      <ErrorLabel show={showError || forceShowError} error={error} forceShowError={forceShowError} />
    </div>
  );
}

export default SubLabelSection;
